module.exports = __webpack_public_path__ + "img/premium.51607a7d.png";